import React from "react";
import { Route, Routes } from "react-router-dom";
import Register from "../../pages/Register";
import RegisterUser from "../../pages/RegisterUser";
import RegisterCopilotExpert from "../../pages/RegisterCopilotExpert";

const RegisterRouting = () => {
  return (
    <Routes>
      <Route path="/" element={<Register />} />
      <Route path="user-register" element={<RegisterUser />} />
      <Route path="copilot-register" element={<RegisterCopilotExpert />} />
    </Routes>
  );
};

export default RegisterRouting;
